import { resolveImagePath } from "@/utils/imageMap";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

interface NavItem {
  href: string;
  label: string;
}

const navItems: NavItem[] = [
  { href: "/", label: "HOME" },
  { href: "/who-we-are", label: "WHO WE ARE" },
  { href: "/our-famous-bean-supper", label: "OUR FAMOUS BEAN SUPPER" },
  { href: "/valentines-day-bake-sale", label: "VALENTINE'S DAY BAKE SALE" },
  { href: "#", label: "MORE" },
];

export function Header() {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const currentIndex = navItems.findIndex(item => item.href === location.pathname);
    if (currentIndex >= 0) {
      setActiveIndex(currentIndex);
    }
  }, [location.pathname]);

  return (
    <header 
      className="bg-primary-muted"
    >
      {/* Header content */}
      <div>
        {/* Top navigation bar */}
        <div className="bg-primary-muted">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-24">
              {/* Logo */}
              <div className="flex-shrink-0">
                <img 
                  src={resolveImagePath('/images/pccc-logo.jpg')} 
                  alt="Prides Corner Community Church"
                  className="h-20 w-auto bg-white rounded px-3 py-2"
                />
              </div>
              
              {/* Navigation */}
              <nav className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-8 relative">
                  {navItems.map((item, index) => (
                    <a
                      key={item.href}
                      href={item.href}
                      className="relative text-white hover:text-gray-200 px-3 py-2 text-sm font-medium uppercase tracking-wide overflow-hidden"
                    >
                      {item.label}
                      {/* Animated underline */}
                      {index === activeIndex && (
                        <div className="absolute bottom-0 left-0 h-0.5 bg-white animate-expand-right"></div>
                      )}
                    </a>
                  ))}
                </div>
              </nav>
            
            {/* Mobile menu button and Icons */}
            <div className="flex items-center space-x-4">
              {/* Search and Cart Icons - hidden on mobile */}
              <div className="hidden sm:flex items-center space-x-4">
                <button className="text-white hover:text-gray-200">
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </button>
                <button className="text-white hover:text-gray-200">
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                  </svg>
                </button>
              </div>
              
              {/* Mobile menu button */}
              <button
                className="md:hidden text-white hover:text-gray-200"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {mobileMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
        </div>
        
        {/* Mobile menu dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-primary-muted bg-opacity-90">
              {navItems.map((item, index) => (
                <a
                  key={item.href}
                  href={item.href}
                  className={`block px-3 py-2 text-base font-medium uppercase tracking-wide ${
                    index === activeIndex
                      ? 'text-white bg-primary-darker border-l-4 border-white'
                      : 'text-gray-200 hover:text-white hover:bg-primary-darker'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              
              {/* Mobile search and cart buttons */}
              <div className="flex items-center space-x-4 px-3 py-2">
                <button className="text-white hover:text-gray-200">
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </button>
                <button className="text-white hover:text-gray-200">
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* Hero image section - new image with built-in wording */}
        <div className="w-full">
          <img 
            src={resolveImagePath('/images/new-hero-image.jpg')}
            alt="Prides Corner Congregational Church - Welcome"
            className="w-full h-auto"
          />
        </div>
      </div>
    </header>
  );
}